import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellPresetSizeM from './IconWellPreset_size_m';

const props: CreateIconArguments = {
  l: IconWellPresetSizeM,
  m: IconWellPresetSizeM,
  s: IconWellPresetSizeM,
  xs: IconWellPresetSizeM,
  name: 'IconWellPreset',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
